import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "_px-6" }
const _hoisted_2 = {
  class: "gfu-grid _tac",
  role: "list"
}
const _hoisted_3 = { class: "gfu-hd gfu-hd--h2 _mt-2" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_external_link = _resolveComponent("external-link")
  const _component_localize = _resolveComponent("localize")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.stats, (item) => {
        return (_openBlock(), _createElementBlock("div", {
          key: item.title,
          class: _normalizeClass($options.classList),
          role: "listitem"
        }, [
          _createElementVNode("h5", _hoisted_3, _toDisplayString(item.value), 1 /* TEXT */),
          _createVNode(_component_localize, {
            resource: item.title,
            tag: "span",
            class: "gfu-bt--caption"
          }, {
            default: _withCtx(() => [
              (item.linkText)
                ? (_openBlock(), _createBlock(_component_external_link, {
                    key: 0,
                    href: item.linkUrl,
                    "format-key": "0",
                    class: "gfu-link gfu-link--accent _tdu"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(item.linkText), 1 /* TEXT */)
                    ]),
                    _: 2 /* DYNAMIC */
                  }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["href"]))
                : _createCommentVNode("v-if", true)
            ]),
            _: 2 /* DYNAMIC */
          }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["resource"])
        ], 2 /* CLASS */))
      }), 128 /* KEYED_FRAGMENT */))
    ])
  ]))
}